import React from 'react';
import { motion } from 'framer-motion';
import { FiCheckCircle, FiExternalLink } from 'react-icons/fi';
import SectionHeader from './SectionHeader';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const ConsultingSection = ({ content }) => (
  <section id="consulting" className="section section-dark">
    <div className="container section-stack">
      <SectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.intro}
      />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
        transition={{ duration: 0.55, delay: 0.05 }}
      >
        <a
          className="consulting-link"
          href={content.linkHref}
          target="_blank"
          rel="noreferrer"
        >
          <FiExternalLink />
          {content.linkLabel}
        </a>
      </motion.div>

      <div className="about-grid consulting-grid">
        {content.cards.map((card, index) => (
          <motion.div
            key={card.title}
            className="content-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.55, delay: index * 0.1 }}
          >
            <h3>{card.title}</h3>
            {card.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </motion.div>
        ))}
      </div>

      <motion.div
        className="consulting-note-card"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
        transition={{ duration: 0.55, delay: 0.15 }}
      >
        <div className="consulting-bullets">
          {content.bullets.map((bullet) => (
            <div key={bullet} className="consulting-bullet">
              <FiCheckCircle />
              <span>{bullet}</span>
            </div>
          ))}
        </div>
        <p className="consulting-note">{content.note}</p>
      </motion.div>
    </div>
  </section>
);

export default ConsultingSection;
